// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"AddingProduct_pageHolder__1l4-u","centerHolder":"AddingProduct_centerHolder__3P-JN"};